import Header from '../../components/Header';
import Lateral from '../../components/Lateral';
import Division from '../../components/Division';
import Title from '../../components/Title';
import './dashboard.css'
import api from '../../config';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { convertDateAndHour, convertDateToBrazilianFormat, custom, handleInput, showMessageError } from '../../classes/functions';
import { FaCheck, FaCog } from 'react-icons/fa';
import HighchartsReact from 'highcharts-react-official';
import { HighchartsOptions } from '../../classes/highcharts';
import { FaFilter } from "react-icons/fa";
import Modal from "react-modal";
import ModalPeriodFilters from './components/modalPeriodFilters';

export default function Dashboard(){
  const [messagesByUser, setMessagesByUser] = useState([]);
  const [carrying, setCarrying] = useState(true);
  const [messageSearch, setMessageSearch] = useState('');
  const [users, setUsers] = useState([]);
  const [usersOptions, setUsersOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState(0);
  const [showModalPeriodFilters, setShowModalPeriodFilters] = useState(false);
  const [dashboardDatas, setDashboardDatas] = useState({});
  const [features, setFeatures] = useState({});
  const [periods, setPeriods] = useState();
  const Highcharts = require("highcharts/highmaps");
  const hasScrollbar = true;
  const isFeature = true;
  const highchartsOptionsOperations = {
    chart: {
      type: 'column',
    },
    yAxis: {
      title: {
        enabled: false,
      },
    },
    title: {
      text: 'Operações Período:',
      align: 'left',
    },
    xAxis: {
      categories: ['Dia Atual', 'Mês Atual', 'Ano Atual', 'Período'],
      labels: {
        rotation: 0
      },
      crosshair: true,
      accessibility: {
        description: 'Operações Período:',
      },
    },
    plotOptions: {
      column: {
        depth: 25,
        dataLabels: {
          enabled: true,
          format: '{point.y}',
        },
      },
    },
    series: [
      {
        name: 'Entrada',
        data: [periods?.dia?.entrada, periods?.mes?.entrada, periods?.ano?.entrada, periods?.periodo?.entrada],
      },
      {
        name: 'Saída',
        data: [periods?.dia?.saida, periods?.mes?.saida, periods?.ano?.saida, periods?.periodo?.saida],
      },
    ],
  }
  const [highchartsOptions, setHighchartsOptions] = useState([]);

  const operationsDateFrom = localStorage.getItem("operationsDateFrom" || "");
  const operationsDateUntil = localStorage.getItem("operationsDateUntil" || "");
  const operationsFeature = localStorage.getItem("operationsFeature" || "");
  const operationsValue = localStorage.getItem("operationsValue" || "");
  const [operationsFilters, setOperationsFilters] = useState({
    dataDe: operationsDateFrom || new Date().toISOString().split('T')[0],
    dataAte: operationsDateUntil || new Date().toISOString().split('T')[0],
    caracteristica: operationsFeature || "",
    valor: operationsValue || ""
  });
  const titulo = "Seja bem-vindo, " + localStorage.nome_usuario + "!";
  const graphicsNames = ["conferencia", "enderacamento", "separacao", "expedicao"];

  const customStyles = {
    container: (provided) => ({
        ...provided,
        width: '12rem'
    })
  }

  function getMessages(){
    let params = `?search=${messageSearch}${selectedUser !== 0 ? ('&to=' + selectedUser) : ''}`;

    api
    .get(`api/messages${params}`)
    .then((response) => {
      const userId = localStorage.getItem('usuario');
      
      let array = [];
      
      response?.data?.result?.map((message) => {
        message?.to?.map((user_id) => {
          if(parseInt(userId) === parseInt(user_id)){
            array.push(message)
          }
        });
      });
      
      setMessagesByUser(array);
      setCarrying(false);
    })
    .catch((error) => {
      console.log(error);
      showMessageError(error.response.data);
      setCarrying(false);
    })
  }

  function getUsers(){
    api
    .get('/api/users/getList')
    .then((response) => {
      let array = [];

      setUsers(response.data);

      response.data.map((data) => {
        array.push({id: data.id, label: data.nome, value: data.nome})
      });

      setUsersOptions(array);
      setCarrying(false);
    })
    .catch((error) => {
      console.log(error);
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  function getPeriods(){
    api
    .get(`/api/dashboard/operacao?dataDe=${convertDateToBrazilianFormat(operationsFilters?.dataDe ? operationsFilters?.dataDe : operationsDateFrom)}&dataAte=${convertDateToBrazilianFormat(operationsFilters?.dataAte ? operationsFilters?.dataAte : operationsDateFrom)}&caracteristica=${operationsFilters?.caracteristica}&caracteristica_valor=${operationsFilters?.valor?.toUpperCase()}`)
    .then((response) => {
      setPeriods(response.data.operacao);
      setCarrying(false);
    })
    .catch((error) => {
      console.log(error);
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  function getDashboardDatas(){
    setCarrying(true);

    api
    .get("/api/home/dashboard")
    .then((response) => {
      let adaptedDashboardValuesToGraphics = adaptDashboardValuesToGraphics(response.data);

      setDashboardDatas(adaptDashboardValuesToGraphics(response.data));
      setHighchartsOptions([...highchartsOptions, 
        new HighchartsOptions("Conferência", adaptedDashboardValuesToGraphics?.conferencia, !hasScrollbar, !isFeature).createHighchartObject(),
        new HighchartsOptions("Endereçamento", adaptedDashboardValuesToGraphics?.enderacamento, !hasScrollbar, !isFeature).createHighchartObject(),
        new HighchartsOptions("Requisições em Separação", adaptedDashboardValuesToGraphics?.separacao, !hasScrollbar, !isFeature).createHighchartObject(),
        new HighchartsOptions("Expedição", adaptedDashboardValuesToGraphics?.expedicao, !hasScrollbar, !isFeature).createHighchartObject()
      ]);

      if(response.data.caracteristica){
        setFeatures(response.data.caracteristica);
      }
      setCarrying(false);
    })
    .catch((error) => {
      console.log(error);
    });
  }

  function adaptDashboardValuesToGraphics(values){
    let objectForGraphics = {};

    graphicsNames.map((graphicName) => {
      let formatedArrayForCurrentGraphic = [];

      for(var i = 0; i < values[graphicName]?.data?.length; i++){
        let currentGraphicValues = {data: 0, name: "", key: ""};

        currentGraphicValues.data = [values[graphicName]?.data[i]];
        currentGraphicValues.name = values[graphicName]?.labels[i];
        currentGraphicValues.key = values[graphicName]?.chave[i];

        formatedArrayForCurrentGraphic.push(currentGraphicValues);
      }

      objectForGraphics = {...objectForGraphics, [graphicName]: formatedArrayForCurrentGraphic};
    });

    return objectForGraphics;
  }

  function checkDashboardColor(index){
    let colors = ["rgb(44,175,254)", "rgb(84,79,197)", "rgb(0,226,114)", "rgb(254,106,53)", "rgb(107,138,188)", "rgb(213,104,251", "rgb(46,224,202)", "rgb(156,204,204)", "rgb(223,223,18)", "rgb(13,24,21)", "rgb(178,14,232)", "rgb(256,204,224)"];

    for(var colorIndex = 0; colorIndex < colors.length; colorIndex++){
      if(colorIndex === index){
        return colors[colorIndex];
      }
    }
  }

  useEffect(() => {
    getMessages();
    getUsers();
    getDashboardDatas();
  }, [])

  useEffect(() => {
    if(messageSearch && selectedUser){
      getMessages();
    }
  }, [messageSearch, selectedUser]);

  useEffect(() => {
    setTimeout(() => {
      getPeriods();
    }, [1000]);
  }, [operationsFilters.caracteristica, operationsFilters.valor]);

  useEffect(() => {
    const arrayWithFeatures = Object.entries(features);
    if(arrayWithFeatures?.length !== 0){
      arrayWithFeatures.map((feature) => {
        highchartsOptions.push(new HighchartsOptions(feature[0], feature[1], hasScrollbar, isFeature).createHighchartObject());
        setHighchartsOptions(highchartsOptions);
      });
    }
  }, [features]);

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>

      <ModalPeriodFilters showModalPeriodFilters={{state: showModalPeriodFilters, setState: setShowModalPeriodFilters}} operationsFilters={{state: operationsFilters, setState: setOperationsFilters}} getPeriods={getPeriods} />

      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content" style={{display: "flex", flexDirection: "column"}}>
          <Title name={titulo}/>
          <div className="graphics">
            {highchartsOptions.map((highchartOption, index) => {
              return (
                <div className="graphics__div" key={index}>
                  <HighchartsReact highcharts={Highcharts} options={highchartOption} />
                  <ul className="graphics___options">
                    <div>
                      {dashboardDatas[graphicsNames[index]]?.map((conference, dashboardDataIndex) => {
                        return (
                          <a href={`/${(graphicsNames[index] === "separacao" || graphicsNames[index] === "expedicao") ? "product_requests" : "receipt_documents"}?status=${conference?.key}`} style={{color: "black"}} target="_blank" >
                            <li className="graphics____option" key={dashboardDataIndex}>
                              <div style={{backgroundColor: checkDashboardColor(dashboardDataIndex)}}></div>
                              <h2>{conference?.name}</h2>
                            </li>
                          </a>
                        )
                      })}
                    </div>
                  </ul>
                </div>
              )
            })}
            <div className="graphics__div" style={{width: `${highchartsOptions.length % 3 === 1 ? "66%" : "32%"}`}}>
              <HighchartsReact highcharts={Highcharts} options={highchartsOptionsOperations} />
                <div className="period-filter-infos">
                  <button type="button" onClick={() => setShowModalPeriodFilters(true)} id="button-open-period-modal">Filtrar</button>
                    <input type="date" name="dataDe" value={operationsFilters?.dataDe} onBlur={getPeriods} onChange={(e) => {handleInput(operationsFilters?.setState, e); localStorage.setItem("operationsDateFrom", e.target.value)}} disabled />
                    <input type="date" name="dataAte" value={operationsFilters?.dataAte} onBlur={getPeriods} onChange={(e) => {handleInput(operationsFilters?.setState, e); localStorage.setItem("operationsDateUntil", e.target.value)}} disabled />
                </div>
                <ul className="graphics___options" style={{top: "3%", left: "50%", width: "auto", height: "auto", alignItems: "center", backgroundColor: "blue"}}>
                  <div>
                    <li className="graphics____option">
                      <div style={{backgroundColor: "rgb(44,175,254)"}}></div>
                      <h2>ENTRADA</h2>
                    </li>
                    <li className="graphics____option">
                      <div style={{backgroundColor: "rgb(84,79,197)"}}></div>
                      <h2>SAÍDA</h2>
                    </li>
                  </div>
                </ul>
              </div>
            </div>
          <div className='card-message-header'>
            <h2 className='card-message-title'>Últimas mensagens recebidas</h2>
            <div className='card-message__filters'>
              <input className='card-message___input' type='text' value={messageSearch} onChange={(e) => setMessageSearch(e.target.value)} placeholder='Pesquisar...' />
              <Select options={usersOptions} onChange={(e) => setSelectedUser(e.id)} styles={customStyles} />
            </div>
          </div>
          <ul className='card-message'>
            {messagesByUser?.map((messageByUser, index) => {
              if(index <= 20){
                return (
                  <li className='card-message__item' key={index}>
                    <div>
                      <h3 className='card-message___title'>{messageByUser.title}</h3>
                      <p className='card-message___message' id="message">{messageByUser.message}</p>
                    </div>
                    <div>
                      <p className='card-message___message'>{convertDateAndHour(messageByUser.created_at)}</p>
                      <p className='card-message___message'>Por: {users?.filter((user) => user?.id === messageByUser?.created_by)[0]?.nome || "Não encontrado"}</p>
                    </div>
                  </li>
                )
              }
            })}
          </ul>
        </div>}
    </div>
  )
}